// Endpoints de tempo real — `/v1/metricas/realtime/*` (MET-05/20).
//
// Polling, e não WS: o WS do módulo carrega só o SINAL (`metrics.alert.raised`
// etc.); empurrar a lista inteira multiplicaria o tráfego pelo número de
// atendentes online. A view aplica `pollingInterval: 20_000` +
// `skipPollingIfUnfocused: true`, e SÓ na aba `tempo-real`.
import { api } from '@/lib/api';
import type { MetricsPipelineDto, RealtimeList, WithEnvelope } from '../model';
import { metricsUrl, type MetricsListArgs, type MetricsQueryArgs } from './shared';

export const metricsRealtimeApi = api.injectEndpoints({
  endpoints: (build) => ({
    /** MET-05 — na fila, sem primeira resposta. */
    metricsRealtimeNoResponse: build.query<WithEnvelope<RealtimeList>, MetricsListArgs>({
      query: (args) => metricsUrl('realtime/sem-resposta', { ...args }),
      providesTags: ['MetricsRealtime'],
    }),
    /**
     * MET-05 — FOTO de onde os atendimentos abertos estão agora. NÃO é o funil:
     * o funil é coorte do período; este é o instante, e o filtro de data não se
     * aplica a ele.
     */
    metricsPipeline: build.query<WithEnvelope<MetricsPipelineDto>, MetricsQueryArgs>({
      query: (args) => metricsUrl('realtime/pipeline', { ...args }),
      providesTags: ['MetricsRealtime'],
    }),
    /** MET-20 — paradas: última mensagem foi nossa e o cliente sumiu. */
    metricsRealtimeStalled: build.query<WithEnvelope<RealtimeList>, MetricsListArgs>({
      query: (args) => metricsUrl('realtime/paradas', { ...args }),
      providesTags: ['MetricsRealtime'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useMetricsRealtimeNoResponseQuery,
  useMetricsRealtimeStalledQuery,
  useMetricsPipelineQuery,
} = metricsRealtimeApi;
